export default class UrlEncodeDecode {

    static STATE_NAME = "state";
    
    static encode (string) {
        const encodedString = btoa(encodeURIComponent(string));
        return encodedString;
    }

    static decode (string) {
        return decodeURIComponent(atob(string));
    }
}